import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { GUIDE_COST_DISPLAY } from 'constants/premium-services';
import { siteFromRootSiteSelector } from 'selectors/root-site';

export const useGuideCostDisplay = () => {
  const { siteSlug } = useParams();
  const { guideCostDisplay } = useSelector(siteFromRootSiteSelector(siteSlug));

  return {
    hidden: guideCostDisplay === GUIDE_COST_DISPLAY.hideAll,
    paysInCredits: guideCostDisplay === GUIDE_COST_DISPLAY.creditsOnly,
  };
};
